import React from 'react'

export default () => {
  return (
    <div>
        <h2>Based on your responses, it sounds like you might have a form of <strong className="text-decoration" data-tip="A disturbance of the inner ear caused by being in motion, often accompanied by nausea and sometimes vomiting.">Motion Sickness.</strong> </h2>
        <p>Sometimes it helps to have a clear view of your surroundings and the direction you are moving.</p>
        <p>Motion sickness if often triggered by focusing on a stationary target while your body is actually moving. Because of this, if you're prone to motion sickness you should avoid reading or watching TV while on a car or bus, and you may find that sitting in the front seat helps you to feel less ill.</p>
        <a  id="Motion Sickness" href="https://www.rehabmart.com/post/why-am-i-dizzy-top-5-causes-of-dizziness-what-to-do" target="_black">read more about this condition ></a>
    </div>
  )
}
